import { baseApi, decodeProductExtensionEnvelope, resourceScopeTag, resourceTag, type ProductExtensionEnvelope } from '@krp/client-runtime'

import { OWN_PRODUCT_TAG } from '../../nomenclature/api/nomenclatureApi'
import { OWN_NOMENCLATURE_URLS } from '../../nomenclature/api/urls'

/** Вид, который служба своей базы пишет в `kind` конверта расширения. */
export const OWN_EXTENSION_KIND = 'own'

export interface OwnProductExtensionArgs {
  resourceId: string
  productId: string
}

/** Расширение карточки своей базы в ОБЩЕМ `baseApi`. Тег карточки тот же, что у окна товара: правка перечитывает и расширение. */
export const ownProductExtensionApi = baseApi.enhanceEndpoints({ addTagTypes: [OWN_PRODUCT_TAG] }).injectEndpoints({
  endpoints: (build) => ({
    ownProductExtension: build.query<ProductExtensionEnvelope, OwnProductExtensionArgs>({
      query: ({ resourceId, productId }) => ({
        url: OWN_NOMENCLATURE_URLS.productExtension(resourceId, productId),
        decode: decodeProductExtensionEnvelope(OWN_EXTENSION_KIND),
      }),
      providesTags: (_result, _error, { resourceId, productId }) => [
        resourceTag(OWN_PRODUCT_TAG, resourceId, productId),
        resourceScopeTag(resourceId),
      ],
    }),
  }),
})

export const { ownProductExtension } = ownProductExtensionApi.endpoints
